module.exports = __webpack_public_path__ + "img/state_lock.bf1f57a0.png";